var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFarm = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.11843 8.21322C0.467196 7.74939 0.467196 6.78202 1.11843 6.31819L4.96942 3.57545L8.80939 0.840539C9.4436 0.388847 10.2944 0.388847 10.9286 0.840539L14.7686 3.57545L18.6196 6.31819C19.2708 6.78202 19.2708 7.74939 18.6196 8.21322L17.0734 9.31447L14.7686 10.956L10.9286 13.6909C10.2944 14.1426 9.4436 14.1426 8.80939 13.6909L4.96942 10.956L1.11843 8.21322ZM1.69856 7.13272C1.60715 7.19782 1.60715 7.33359 1.69856 7.39869L5.25948 9.93485L9.00712 7.26571L5.25948 4.59656L1.69856 7.13272ZM6.12136 3.98271L9.86901 6.65185L13.6166 3.98271L10.3485 1.65507C10.0615 1.45067 9.6765 1.45067 9.38952 1.65507L6.12136 3.98271ZM14.4785 4.59656L10.7309 7.26571L14.4785 9.93485L16.4932 8.49994L18.0395 7.39869C18.1309 7.33359 18.1309 7.19782 18.0395 7.13272L14.4785 4.59656ZM13.6166 10.5487L9.86901 7.87956L6.12136 10.5487L9.38952 12.8763C9.6765 13.0807 10.0615 13.0807 10.3485 12.8763L13.6166 10.5487Z",
    fill: "#AFAFAF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFarm);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/farm.37e5cdb8c5f4b672dc2e857bebdd0fbd.svg";